<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="150"
    >

    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import moment from 'moment'
const { v4: uuidv4 } = require('uuid')

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      video_url: '',
      audio_url: '',
      translate_script: '',
      product: '',
      product_url: '',
      users: [],
      props: [],
      scripts: [],
      rid_subtitles: '需要',
      covert_face: '需要',
      covert_mouth: '需要',
      face_url: '',
      faceList: [],
      videoModelList: [],
      visible: false,
      short_video_work_type_id: '',
      text: '',
      scene: '',
      video_model_url: '',
      formValidate: {
      },
      ruleValidate: {
      }
    }
  },
  watch: {
  },
  methods: {
    handleView (name) {
      this.visible = true
      this.imgName = name
    },

    handleDownload (url) {
      window.open(url, '_blank')
    },
    setFacePath (arary) {
      for (var i = 0; i < arary.length; i++) {
        this.faceList.push(arary[i].face_path)
      }
    },
    setEditData (params) {
      var id_url = params.covertAudio.translateText.checkSrtTask.shortVideoTask.id_url
      var url = params.covertAudio.translateText.checkSrtTask.shortVideoTask.url
      this.audio_url = params.covertAudio.source_path
      this.video_url = id_url == null ? url : id_url

      this.rid_subtitles = params.covertAudio.translateText.checkSrtTask.shortVideoTask.rid_subtitles ? '需要' : '不需要'
      this.covert_face = params.covertAudio.translateText.checkSrtTask.shortVideoTask.covert_face ? '需要' : '不需要'
      this.covert_mouth = params.covertAudio.translateText.checkSrtTask.shortVideoTask.covert_mouth ? '需要' : '不需要'
      this.face_url = params.covertAudio.translateText.checkSrtTask.shortVideoTask.face_url

      this.scene = params.covertAudio.translateText.translate_scene
      this.text = params.covertAudio.translateText.translate_text
      this.short_video_work_type_id = params.covertAudio.translateText.checkSrtTask.shortVideoTask.short_video_work_type_id

      if (params.covertAudio.translateText.scene_json != null) {
        var scene = JSON.parse(params.covertAudio.translateText.scene_json)
        this.scripts = scene.scripts
        this.users = scene.users
        this.props = scene.props
        this.translate_script = scene.translate_script
        this.product = scene.product
        this.product_url = scene.product_url
      }

      if (params.output_video_path != null) {
        var video_path_array = params.output_video_path.split('/')
        this.show_video_path = video_path_array[video_path_array.length - 1]
      }

      if (params.video_model_url != null) {
        this.videoModelList = JSON.parse(params.video_model_url)
      }
    }
  }
}
</script>

<style>
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>
